module.exports = __webpack_public_path__ + "img/diesel-locomotive-06.35aee00b.png";